import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-column align-items-center text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Step 1:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Set your device to pairing mode", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Step 2:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Click to copy following token and paste on device setting page", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Step 3:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Connect to Quokka WiFi and then setting page will pop up", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, [
  /*#__PURE__*/_createTextVNode(" * Please "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://192.168.4.1",
    target: "_blank"
  }, "click"),
  /*#__PURE__*/_createTextVNode(" if no pop up window after changing WiFi connection * ")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Step 4:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, " After finishing device setting page, press following button and wait for pairing ", -1)
const _hoisted_11 = { class: "flex align-items-center" }
const _hoisted_12 = { class: "p-input-icon-left m-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_14 = { class: "flex flex-wrap" }
const _hoisted_15 = { class: "flex flex-wrap" }

import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Toast from "primevue/toast";
import Card from "primevue/card";
import Fieldset from "primevue/fieldset";
import InputText from "primevue/inputtext";
import { computed, onBeforeMount, ref } from "vue";
import { useDeviceStore } from "@/store/device.store";
import { useToast } from "primevue/usetoast";
import { BoxResponse, TmdResponse } from "@evolutivelabs/quokka-common";
import { storeToRefs } from "pinia";
import BoxEditorDialog from "@/components/BoxEditorDialog.vue";
import { useTargetStore } from "@/store/target.store";
import { useCombinedTargetStore } from "@/store/combinedTarget.store";
import BoxCard from "@/components/BoxCard.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const filterInput = ref("");
const deviceStore = useDeviceStore();
const showDialog = ref(false);
const token = ref("");
const isLoadingToken = ref(false);
const isCheckingPairStatus = ref(false);
const isTokenCopied = ref(false);
const deviceIdToCreate = ref("");
const checkPairTimer = ref<number>();
onBeforeMount(() => {
  deviceStore.fetch();
});

async function open() {
  showDialog.value = true;
  isLoadingToken.value = true;
  isCheckingPairStatus.value = false;
  const res = await deviceStore.getCreateTokenResponse();
  deviceIdToCreate.value = res.deviceId;
  token.value = `${res.token}@${res.deviceId}`;
  isLoadingToken.value = false;
  isTokenCopied.value = false;
}

function cleanup() {
  clearInterval(checkPairTimer.value);
}
const boxEditor = ref<InstanceType<typeof BoxEditorDialog>>();
function editBox(b: BoxResponse) {
  boxEditor.value?.open(b);
}

const toast = useToast();
async function copyToken() {
  await navigator.clipboard.writeText(token.value);
  toast.add({
    severity: "success",
    summary: "Token Copied",
    life: 3000,
  });
  isTokenCopied.value = true;
}

const { tmds, boxes } = storeToRefs(deviceStore);
const filteredTmds = computed<TmdResponse[]>(() =>
  tmds.value.filter((d) => d.name.includes(filterInput.value))
);
const filteredBoxes = computed<BoxResponse[]>(() =>
  boxes.value.filter((d) => d.name.includes(filterInput.value))
);

onBeforeMount(async () => {
  await Promise.all([
    useTargetStore().fetch(),
    useCombinedTargetStore().fetch(),
  ]);
});

function checkPairStatus() {
  isCheckingPairStatus.value = true;
  checkPairTimer.value = setInterval(async () => {
    if (tmds.value.some((d) => d.id === deviceIdToCreate.value)) {
      clearInterval(checkPairTimer.value);
      showDialog.value = false;
      isCheckingPairStatus.value = false;
      toast.add({ severity: "success", summary: "Device Paired", life: 3000 });
    } else {
      await deviceStore.fetch();
    }
  }, 2000);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast)),
    _createVNode(_unref(Dialog), {
      header: "New Device Steps",
      modal: true,
      class: "w-5",
      dismissableMask: true,
      visible: showDialog.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showDialog).value = $event)),
      "content-class": "flex justify-content-center pt-2",
      onHide: cleanup
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createVNode(_unref(Button), {
            label: "token",
            class: "p-button-outlined mb-3",
            icon: "pi pi-copy",
            "icon-pos": "right",
            onClick: copyToken,
            loading: isLoadingToken.value
          }, null, 8, ["loading"]),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _createVNode(_unref(Button), {
            label: "pair",
            class: "p-button-outlined",
            icon: "pi pi-link",
            "icon-pos": "right",
            onClick: checkPairStatus,
            loading: isCheckingPairStatus.value,
            disabled: !isTokenCopied.value
          }, null, 8, ["loading", "disabled"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", _hoisted_12, [
        _hoisted_13,
        _createVNode(_unref(InputText), {
          type: "text",
          modelValue: filterInput.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterInput).value = $event)),
          modelModifiers: { trim: true, lazy: true },
          placeholder: "Search"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_unref(Button), {
        icon: "pi pi-plus",
        label: "New Device",
        onClick: open
      })
    ]),
    _createVNode(_unref(Fieldset), {
      legend: "TMDs:",
      class: "mx-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredTmds), (tmd) => {
            return (_openBlock(), _createBlock(_unref(Card), {
              class: "shadow-2 m-3 w-3",
              key: tmd.id
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(tmd.name), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(Fieldset), {
      legend: "Boxes:",
      class: "mx-4 mt-2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredBoxes), (box) => {
            return (_openBlock(), _createBlock(BoxCard, {
              box: box,
              key: box.id,
              onEditBox: ($event: any) => (editBox(box))
            }, null, 8, ["box", "onEditBox"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(BoxEditorDialog, {
      ref: (_value, _refs) => {
        _refs['boxEditor'] = _value
        boxEditor.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})